import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "field" }
const _hoisted_2 = { class: "m-3 p-fluid" }
const _hoisted_3 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimeVueInputText = _resolveComponent("PrimeVueInputText")!
  const _component_PrimeVueDropdown = _resolveComponent("PrimeVueDropdown")!
  const _component_FieldErrors = _resolveComponent("FieldErrors")!
  const _directive_focus = _resolveDirective("focus")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", null, _toDisplayString(_ctx.label), 1),
    _createVNode(_component_PrimeVueDropdown, {
      "model-value": _ctx.modelValue,
      loading: _ctx.loading,
      disabled: _ctx.disabled,
      "show-clear": _ctx.showClear,
      options: _ctx.options,
      "option-value": "id",
      "option-label": _ctx.optionLabel,
      "data-key": "id",
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createVNode(_component_PrimeVueInputText, {
            modelValue: _ctx.keyword,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.keyword) = $event)),
            placeholder: "Search",
            disabled: _ctx.loading
          }, null, 8, ["modelValue", "disabled"]), [
            [_directive_focus]
          ])
        ])
      ]),
      _: 1
    }, 8, ["model-value", "loading", "disabled", "show-clear", "options", "option-label"]),
    (_ctx.help)
      ? (_openBlock(), _createElementBlock("small", {
          key: 0,
          class: "block",
          innerHTML: _ctx.help
        }, null, 8, _hoisted_3))
      : _createCommentVNode("", true),
    (_ctx.name)
      ? (_openBlock(), _createBlock(_component_FieldErrors, {
          key: 1,
          "errors-map": _ctx.errorsMap,
          name: _ctx.name
        }, null, 8, ["errors-map", "name"]))
      : _createCommentVNode("", true)
  ]))
}